module.exports = __webpack_public_path__ + "static/media/importSea.12b84c28.png";